export default __webpack_public_path__ + "static/HTH_TABLET-2a3653fafa26a121529674ccbd1e66da.jpg";